import { selectors } from 'app-webtech-core';
import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { LOAD } from './types';
import { PLAYER_CONTENT_KIND, PLAYER_LAST_CONTENT_LOCAL_STORAGE_KEY } from '../constants';
import { LAUNCH_STATE } from '../../application/constants';
import { setPrevContentKind } from '../../guide/actions';
import { playerPropertiesSelector } from '../selectors/properties';
import { denormalizeContent } from '../selectors/content';
import { playerSetInfoBannerThunkAction } from './setInfoBanner';
import { setIsVideoRequestedAction } from './setIsVideoRequested';

const payloadSchema = Joi.object().keys({
  id: Joi.string().required(),
  kind: Joi.string().allow(Object.values(PLAYER_CONTENT_KIND)).required(),
  slug: Joi.string().required(),
});

const playerLoadAction = actionCreator(LOAD, payloadSchema);

const shouldLoad = (oldContent) => (newContent) =>
  !oldContent || oldContent.id !== newContent.id || oldContent.kind !== newContent.kind;

export const playerLoadThunkAction = (payload) => async (dispatch, getState) => {
  const state = getState();

  const { content: oldContent } = playerPropertiesSelector(state);

  const shouldLoadNewContent = shouldLoad(oldContent);
  const newContent = { ...payload };

  if (shouldLoadNewContent(newContent)) {
    const content = denormalizeContent(newContent, state);
    if (content) {
      const { slug, serieSlug } = content;
      const { launchState } = selectors.application.properties(state);
      const slugFull = serieSlug ? `${serieSlug}/${slug}` : slug;
      const prevContentKind = oldContent && oldContent.kind;
      const { trackChannelEvents } = selectors.playbackSession.properties(getState());
      dispatch(
        setPrevContentKind({
          prevContentKind: trackChannelEvents ? prevContentKind : null,
        }),
      );
      if (newContent.kind === PLAYER_CONTENT_KIND.LINEAR_CHANNEL) {
        if (global.window) {
          global.window.localStorage.setItem(PLAYER_LAST_CONTENT_LOCAL_STORAGE_KEY, newContent.id);
        }
      }
      if (newContent.kind === PLAYER_CONTENT_KIND.VOD && launchState === LAUNCH_STATE.APP_LOADED) {
        dispatch(
          setIsVideoRequestedAction({
            videoRequested: true,
            kind: PLAYER_CONTENT_KIND.VOD,
          }),
        );
      }
      dispatch(playerLoadAction({ ...newContent, slug: slugFull }));
      dispatch(playerSetInfoBannerThunkAction(newContent));
    } else {
      dispatch(playerLoadAction({ ...newContent }));
    }
  }
};
